import { EGY_PREFIXES } from '../constants/shared/modals/share-modal';

export const normalizeEgyptPhone = (phone: string) => {
  const trimmed = phone.trim();

  const normalized = trimmed.replace(/^(?:\+20|0020|20)/, '').replace(/^0/, '');

  const isEgypt = EGY_PREFIXES.some((prefix) => normalized.startsWith(prefix));

  const formatted = isEgypt ? `+20${normalized}` : trimmed;

  return { isEgypt, normalized: formatted };
};
